// extracted by mini-css-extract-plugin
export var dot = "add-meal-type-modal-module--dot--76523";
export var form = "add-meal-type-modal-module--form--66072";
export var inputSelect = "add-meal-type-modal-module--input-select--c44dd";
export var loader = "add-meal-type-modal-module--loader--563fa";
export var modal = "add-meal-type-modal-module--modal--b42a8";
export var option = "add-meal-type-modal-module--option--99e94";
export var submitButton = "add-meal-type-modal-module--submit-button--c1244";